export enum WritingStyle {
    default = 'default',
    prefer_academic = 'prefer_academic',
    prefer_business = 'prefer_business',
    prefer_casual = 'prefer_casual',
    prefer_simple = 'prefer_simple',
}
